import React from 'react'
import "./HomeScreen.css"
import "./App.css"
import twitter from "./twitter.png"
import instagram from "./instagram.png"
import NilutpalBaruah_CV from "./NilutpalBaruah_CV.pdf"
function HomeScreen() {
  return (
     <div>
    <div className='home__section'> 
       <div className='top'></div>
          <div className='intro-content'>
             <h5 id="home" className='header'>Hello, World.</h5>
             <h1 id="myname">I'm Nilutpal Baruah.</h1>
                      <p className='intro-position'>
                           <span>Competitive Programmer</span>
                           <span>Developer</span>
                           <span>Wanderer</span>  
                       </p>
              <div>
              <a href={NilutpalBaruah_CV}> <button className='resume__button'>Download Resume</button> </a>     
              </div>
           </div>
           <div className='gap'></div>
           <div className='social-handle'>
           <ul className='intro-social'>
                <li id="facebook"><a  href="https://twitter.com/Nilotpal6317670"><img className='logo' id="twitter" src={twitter} alt="twitterlogo" /></a></li>
                <li><a href="https://www.instagram.com/nilotpalbarua/"><img className='logo' id='instagram' src={instagram} alt="" /></a></li>
                <li id="github"><a href="https://github.com/nilutpalbr"> <img className='logo' id='github'  src="https://www.kindpng.com/picc/m/128-1280192_github-logo-png-github-png-transparent-png.png" alt="" /> </a></li>
                <li><a href="https://www.linkedin.com/in/nilutpal-baruah-b448a01b8/"><img className='logo' id='linkedin' src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/640px-LinkedIn_logo_initials.png" alt="" /> </a></li>
                
             </ul>
           </div>
    </div>
    </div>
  )
};

export default HomeScreen
